<form (ngSubmit)="save()" class="popup-container">
  <div class="popup-header">
    <h2>Change title</h2>
  </div>

  <div class="popup-body">
    <mat-form-field appearance="outline" class="full-width compact-field">
      <mat-label>Title</mat-label>
      <input 
        matInput 
        id="title" 
        name="title" 
        required 
        [(ngModel)]="title" 
        placeholder="Enter new title..."
        cdkFocusInitial>
    </mat-form-field>
  </div>

  <div class="popup-footer">
    <button 
      mat-flat-button 
      type="submit" 
      class="env-btn" 
      [disabled]="!title || !title.trim()">
      Save
    </button>
  </div>
</form>